const errorCodeMap: Record<string, string> = {
  "0": "-",
  "1": "落下検知（エラー：本体が宙に浮いています。新しい位置に移動して起動してください）",
  "2": "崖センサーの清掃を試してください",
  "3": "衝突検知",
  "4": "姿勢検知（エラー：本体が宙に浮いています。新しい位置に移動して起動してください）",
  "5": "衝突板が繰り返しトリガーされる",
  "6": "落下が繰り返しトリガーされる",
  "7": "光学フローが異常かどうか",
  "8": "ダストボックスが装着されていますか",
  "9": "水タンクが装着されていますか",
  "10": "水量不足",
  "11": "ダストボックスが満杯",
  "12": "メインブラシ異常",
  "13": "サイドブラシ過電流検知",
  "14": "ファン過電流検知",
  "15": "左駆動輪検知（エラー：左駆動輪に異常があります。駆動輪を確認して清掃してください）",
  "16": "右駆動輪検知（エラー：右駆動輪に異常があります。駆動輪を確認して清掃してください）",
  "17": "回転がスタック検知（エラー：本体が動けなくなっています。新しい位置に移動して起動してください）",
  "18": "前進がスタック検知（エラー：本体が動けなくなっています。新しい位置に移動して起動してください）",
  "19": "充電信号の取得？",
  "20": "バッテリー低下",
  "21": "充電異常検知",
  "22": "バッテリー残量0～100％",
  "23": "ハートビート異常",
  "24": "カメラ遮蔽検知",
  "25": "機器が移動された",
  "26": "光学フローが遮蔽された",
  "27": "赤外線が遮蔽された",
  "28": "充電ドックに電力が供給されていない",
  "29": "バッテリー異常",
  "30": "ファン速度異常",
  "31": "左輪速度異常",
  "32": "右輪速度異常",
  "33": "BMI055加速度計異常",
  "34": "BMI055ジャイロスコープ異常",
  "35": "XV7001ジャイロスコープ異常",
  "36": "左地磁異常",
  "37": "右地磁異常",
  "38": "光学フロー異常",
  "39": "赤外線異常",
  "40": "カメラ異常",
  "41": "強磁場を検知",
  "42": "ウォーターポンプ異常",
  "43": "RTC不一致",
  "44": "AUTOボタンが押し続けられている",
  "45": "3.3V電源異常",
  "46": "カメラが画像を処理しない",
  "47": "エリアが境界を越えている（エラー：経路がブロックされています）",
  "48": "LDSセンサー異常",
  "49": "LDS衝突板がスタックした",
  "50": "ウォーターポンプ異常",
  "51": "フィルターが詰まっている",
  "54": "縁取りセンサー異常",
  "55": "カーペット以外のエリアで起動してください",
  "56": "3D障害物回避センサー異常",
  "58": "超音波センサー異常",
  "59": "進入禁止エリアまたはバーチャルウォールを検知",
  "61": "指定エリアに到達できません（ドアが開いているか、経路上の障害物を取り除いてください）",
  "62": "指定エリアに到達できません（経路上の進入禁止エリアを削除してみてください）",
  "63": "清掃経路がブロックされています（ドアが開いているか、本体周辺の障害物を取り除いてください）",
  "64": "清掃経路がブロックされています（進入禁止エリアを削除するか、本体をこのエリアから移動してください）",
  "65": "本体が進入禁止エリア内にあることを検知",
  "67": "ループに陥り、充電に戻る",
  "68": "充電ドックでモップを取り外すよう促す",
  "69": "左モップ監視",
  "70": "右モップ監視",
  "71": "モップモーター異常",
  "72": "モップモーター過電流",
  "100": "ベースステーションの健康状態フラグ",
  "101": "集塵箱のダスト満杯アラート",
  "102": "集塵箱のダストバッグがは装着されていない",
  "103": "集塵箱のダストカバー異常",
  "104": "集塵箱の詰まり",
  "105": "清水タンクが装着されていない",
  "106": "汚水タンク異常",
  "107": "清水タンクの水量不足",
  "108": "汚水タンクが満杯または装着されていない",
  "109": "汚水管の詰まりを検知",
  "110": "汚水ポンプの破損を検知",
  "111": "洗浄プレートの取り付けが完了していない",
  "112": "洗浄プレートの水位異常",
  "114": "ダストボックスと洗浄プレートを適時に清掃してください",
  "116": "清水タンクを確認してください",
  "117": "ベースステーションに電力が供給されていない",
  "118": "汚水タンクの水位が高すぎる",
  "119": "洗浄プレートの水位が高すぎる",
  "120": "モッププレートが所定の位置にない",
  "121": "ダストバッグの状態を確認してください",
  "122": "上下水設備　タスク完了",
  "123": "上下水設備　清水タンクが空",
  "124": "洗浄プレートが動作停止",
  "125": "汚水タンクの排水異常",
  "130": "本体がカーテンでスリップした",
} as const;

/**
 * Dreameロボットの errorCode から表示用のラベルを取得する
 */
export const getDreameRobotErrorCodeLabel = (errorCode: string) => {
  return errorCodeMap[errorCode] ?? `エラー(${errorCode})`;
};

/**
 * Dreameロボットの errorCode からエラー状態かどうか判定
 * - code = "0"のとき、返り値 false
 */
export const isErrorDreameRobotByErrorCode = (errorCode: string) => {
  return errorCode !== "0";
};
